module.exports = __webpack_public_path__ + "img/pendApprovalIcon.44103d73.png";